import { useFieldMasks } from '@/hooks/usePermissions';

interface MaskedValueProps {
  /** Uppercase mask category, e.g. 'PRICING', 'PAYMENT_INFO' */
  mask: string | readonly string[];
  children: React.ReactNode;
  /** Placeholder shown when the mask is active. Defaults to —  */
  placeholder?: React.ReactNode;
}

/**
 * Renders children when the mask is not active, or a neutral placeholder
 * when the backend has stripped this field from API responses.
 *
 * Use for individual values inside cards and detail rows.
 * For full column hiding in tables, filter the column definition instead.
 */
export function MaskedValue({ mask, children, placeholder = '—' }: MaskedValueProps) {
  const fieldMasks = useFieldMasks();
  const masks: readonly string[] = typeof mask === 'string' ? [mask] : mask;
  const hidden = masks.some((candidate) => fieldMasks.includes(candidate));
  if (hidden) return <span className="text-muted-foreground">{placeholder}</span>;
  return <>{children}</>;
}
